module.exports = "<p>\r\n  batch-history works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-general/batch-history/batch-history.component.html
// module id = 2380
// module chunks = 66